<template>
	<div id="app">
		<transition name="ars-fade">
			<router-view/>
		</transition>
	</div>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style lang="scss">
#app {
	font-family: AvenirNext, Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
